import { format } from "date-fns";
import React, { FC } from "react";
import { DATE_TIME_NO_SECONDS_COMPACT_FORMAT } from "../../../app/constants";
import { IconTimelineArrow } from "../../../assets";
import { Button2 } from "../../../components/Typography";
import { IOrderEventModelExtended } from "./OrderTimeline";
import styles from "./OrderTimeline.module.css";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

interface Props {
  item: IOrderEventModelExtended;
  isFirst: boolean;
}

const calculateHeight = (item: IOrderEventModelExtended, isFirst: boolean) => {
  if (item.span === 0) return "auto";
  if (isFirst) return item.span * 80;
  return item.span * 80 + 26;
};

export const OrderTimelineItem: FC<Props> = ({ item, isFirst }) => {
  return (
    <React.Fragment key={item.eventTime}>
      <div
        className={styles.gap}
        style={{
          minHeight: isFirst ? 0 : 28,
          height: calculateHeight(item, isFirst),
        }}
      >
        {item.difference && (
          <div className={styles["gap-content"]}>
            <IconTimelineArrow />
            {item.difference}
          </div>
        )}
      </div>
      <div className={cx({ item: true, error: item.isError })}>
        <div className={styles.dot} />
        <Button2 className={styles.status}>{item.eventType}</Button2>
        <div className={styles.date}>
          {format(
            new Date(item.eventTime),
            DATE_TIME_NO_SECONDS_COMPACT_FORMAT
          )}
        </div>
      </div>
    </React.Fragment>
  );
};
